<template>
  <div>
    <Bio :extra="extra" :can-access-contact-informations="canAccessContactInformations" />
    <QBtn
      v-if="canDownloadResume"
      class="btn-navigation full-width"
      color="secondary"
      icon="icon-f-download"
      :label="$t('ETAB.BUTTONS.@DOWNLOAD_RESUME')"
      no-caps
      @click="downloadResume"
    />
    <Motivation v-if="isPayedOffer" :extra="extra" />
    <ExtraTipbox v-if="!isPayedOffer && canBeActivated" class="q-mt-md full-width cursor-pointer" @click="activateDemand">
      {{ $t("ETAB.PAGES.RECRUITMENT.CANDIDATE_PROFILE.@SHOW_MOTIVATION_TEXT") }}
    </ExtraTipbox>
    <Experience :extra="extra" />
    <Skills :extra="extra" />
    <Education :extra="extra" />
  </div>
</template>

<script>
  import Bio from "@etab/components/extra/Bio.component.vue";
  import Experience from "@etab/components/extra/Experience.component.vue";
  import Motivation from "@etab/components/extra/Motivation.component.vue";
  import Skills from "@etab/components/extra/Skills.component.vue";
  import Education from "@etab/components/extra/Education.component.vue";
  import { GETTER_EXTRA_GET_CURRENT, GETTER_RECRUITMENT_GET_CURRENT } from "@etab/stores/types";
  import { ExtraService } from "@core/services";
  import { isWeb } from "@core/plugins/mobile";
  import { ETAB_ROUTES } from "@etab/config";
  import { useExtraStore } from "@etab/stores/extra";
  import { useRecruitmentStore } from "@etab/stores/recruitment";
  import { mapStores } from "pinia";

  export default {
    components: {
      Bio,
      Experience,
      Education,
      Motivation,
      Skills,
    },
    computed: {
      ...mapStores(useRecruitmentStore, useExtraStore),
      canBeActivated() {
        return this.recruitment.canBeActivated();
      },
      isPayedOffer() {
        return this.recruitment.isUpfront() || this.recruitment.isUnlocked();
      },
      demandId() {
        return this.$route.params.demandId;
      },
      demandType() {
        return this.$route.params.demandType;
      },
      extra() {
        return this.extraStore[GETTER_EXTRA_GET_CURRENT];
      },
      recruitment() {
        return this.recruitmentStore[GETTER_RECRUITMENT_GET_CURRENT];
      },
      canAccessContactInformations() {
        return ExtraService.canAccessContactInformations({ extra: this.extra, recruitment: this.recruitment });
      },
      canDownloadResume() {
        return isWeb && this.canAccessContactInformations;
      },
    },
    methods: {
      downloadResume() {
        const extraId = this.extra.getId();
        const extraIdentity = this.extra.getIdentity();
        return ExtraService.downloadResume({ extraId, demandId: this.demandId, extraIdentity });
      },
      activateDemand() {
        // go to activation page
        this.$router
          .push({
            name: ETAB_ROUTES.dashboard.recruitment.permanent.activation.payment.name,
            // save the demandId in order to pay for this demand
            params: { demandId: this.demandId, demandType: this.demandType },
            // query the extraId in order to go back to the extra profile once it's paid
            query: { extraId: this.extra.getId() },
          })
          .catch((suppressedError) => {});
      },
    },
  };
</script>
